


import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ResponsiveImageMedia } from './ResponsiveImage.models';

const appModule = namespace('app');

@Component({})
export default class ResponsiveImage extends Vue {
  @Prop() private media!: ResponsiveImageMedia;
  @Prop({ default: true }) private smart!: boolean;
  @Prop({ default: true }) private lazy!: boolean;
  @Prop({ default: true }) private singleShot!: boolean;
  @Prop({ default: false }) private freeAspect!: boolean;
  @Prop() private alt!: string;

  @appModule.State private imageMQ!: keyof ResponsiveImageMedia;

  private currentImageMQ: keyof ResponsiveImageMedia = 'MQ1';
  private enabled = false;
  private inViewport = false;
  private loaded = false;
  private crashed = false;

  private get src(): string {
    if (!this.enabled) return '';

    return this.media[this.currentImageMQ];
  }

  private get state(): string {
    let state = '-loading';

    if (this.crashed) {
      state = '-error';
    } else if (this.loaded) {
      state = '-loaded';
    }

    return state;
  }

  @Emit()
  private load() {
    this.loaded = true;

    return;
  }

  @Emit()
  private error() {
    this.crashed = true;

    return;
  }

  @Watch('src')
  private srcChanged() {
    this.crashed = false;
    this.loaded = false;
  }

  @Watch('imageMQ')
  private MQChanged() {
    this.updateCurrentImageMQ();
  }

  private mounted() {
    if (!this.lazy || this.inViewport) {
      this.enabled = true;
    }
  }

  private onViewportEntered() {
    this.inViewport = true;
    this.enabled = true;

    this.updateCurrentImageMQ();
  }

  private updateCurrentImageMQ() {
    if (this.imageMQ === this.currentImageMQ || (this.smart && this.imageMQ < this.currentImageMQ && !this.crashed))
      return;

    this.currentImageMQ = this.imageMQ;
  }
}
